import { render, staticRenderFns } from "./azure-file.vue?vue&type=template&id=da6f1170&"
import script from "./azure-file.vue?vue&type=script&lang=js&"
export * from "./azure-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports